export const STORAGE_KEYS = {
  currentUser: 'currentUser',
  activeFlags: 'activeFlags',
} as const;
